import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ShieldOff } from 'lucide-react';

const ROLE_HOME: Record<string, string> = {
  SUPER_ADMIN: '/super-admin/dashboard',
  COMPANY_ADMIN: '/company-admin/dashboard',
  DISPATCH_AGENT: '/dispatch/dashboard',
  RECOVERY_OFFICER: '/recovery/dashboard',
  COMPANY_AGENT: '/agent/dashboard',
  INDEPENDENT_USER: '/user/dashboard',
  TRANSPORTER: '/transporter/dashboard',
};

export const Unauthorized: React.FC = () => {
  const { user } = useAuth();
  const home = user ? (ROLE_HOME[user.role] ?? '/login') : '/login';

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f7fa' }}>
      <div style={{ textAlign: 'center', padding: 40 }}>
        <ShieldOff size={64} color="#cbd5e1" style={{ marginBottom: 20 }} />
        <div style={{ fontSize: 72, fontWeight: 800, color: '#e2e8f0', lineHeight: 1 }}>403</div>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#1e293b', margin: '16px 0 8px' }}>Access denied</h1>
        <p style={{ color: '#64748b', marginBottom: 28 }}>You don't have permission to view this page.</p>
        <Link to={home} className="btn btn-primary">Go to Dashboard</Link>
      </div>
    </div>
  );
};
